module.exports = __webpack_public_path__ + "static/media/bree-handout.38ca1b68.pdf";